<generic-list-manager [config]="config"></generic-list-manager>
